import type { LocationQueryValue } from 'vue-router'

/** Resolve only same-origin application paths supplied through redirect queries. */
export function safeRedirectPath(value: LocationQueryValue | LocationQueryValue[] | undefined, fallback: string): string {
  if (typeof value !== 'string' || !value.startsWith('/'))
    return fallback

  try {
    const base = new URL('https://local.invalid')
    const destination = new URL(value, base)

    if (destination.origin !== base.origin)
      return fallback

    return `${destination.pathname}${destination.search}${destination.hash}`
  }
  catch {
    return fallback
  }
}
